// Pressure Point

export function togglePressurePoint(key, rect){
  return (dispatch, getState) => {
      const { currentPP } = getState().pressurePoint;

      const payload = key === currentPP ? null : key;

      dispatch ({ type: 'TOGGLE_PRESSURE_POINT',  currentPP: payload, nodeRect: rect });
    }
}

export function resetPressurePoint(){
  return { type: 'RESET_PRESSURE_POINT',  currentPP: null, nodeRect: null }
}



// WEBPACK FOOTER //
// ./src/actions/pressurePoint.js